import type React from 'react'
import { trackMetaEvent } from './metaPixel'

export const CHECKOUT_URL_MEGAPACK =
  'https://mega-pack-hombre-magnetico.impultienda.ar/checkout'
export const CHECKOUT_URL_UPSELL =
  'https://mega-pack-hombre-magnetico.impultienda.ar/checkout'

let redirecting = false

const goToCheckout = (url: string) => {
  // One InitiateCheckout per click, fired before the navigation starts.
  if (redirecting) return
  redirecting = true

  trackMetaEvent('InitiateCheckout')

  // Small delay so the pixel request leaves the browser before unloading.
  window.setTimeout(() => {
    window.location.href = url
  }, 180)
}

export const handleCheckoutMegapack = (e?: React.MouseEvent) => {
  if (e) {
    e.preventDefault()
  }
  goToCheckout(CHECKOUT_URL_MEGAPACK)
}

export const handleCheckoutUpsell = (e?: React.MouseEvent) => {
  if (e) {
    e.preventDefault()
  }
  goToCheckout(CHECKOUT_URL_UPSELL)
}

export const scrollToPurchase = (e?: React.MouseEvent) => {
  if (e) {
    e.preventDefault()
  }
  const el = document.getElementById('purchase')
  if (el) {
    el.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    })
  }
}
